import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { todayStr } from '@/utils';
import ModalForm from '@/common/components/modal-form';
import TutorialSpotlight from '@/common/components/tutorial-spotlight';
import CreateBudgetForm from './form-create';
const CREATE_STEPS = [
    {
        title: 'Иконка и название',
        text: 'Выберите иконку для бюджета и введите его название. Это обязательное поле.',
        selector: '[data-tut="create-icon-name"]',
        place: 'right',
    },
    {
        title: 'Валюта и настройки',
        text: 'Выберите валюту бюджета и день начала недели для календаря.',
        selector: '[data-tut="create-settings"]',
        place: 'left',
    },
    {
        title: 'Стартовый баланс',
        text: 'Если у вас уже есть средства — укажите начальный баланс. Он станет первой операцией в бюджете.',
        selector: '[data-tut="create-balance"]',
        place: 'top',
    },
    {
        title: 'Накопления',
        text: 'Включение добавляет третий тип операций — для целей и сбережений. Это отдельный контур, не обычный расход. Можно включить позже в настройках.',
        selector: '[data-tut="create-savings"]',
        place: 'top',
    },
    {
        title: 'Создание',
        text: 'Когда всё заполнено — нажмите «Создать». Бюджет появится на главной странице.',
        selector: '[data-tut="create-submit"]',
        place: 'top',
    },
];
function ModalCreateForm({ onClose, onCreate }) {
    const [data, setData] = useState(null);
    const submit = () => {
        if (data == null)
            return;
        onCreate(data);
    };
    return (_jsxs(ModalForm, { onSubmit: submit, onClose: onClose, headlineText: "\u041D\u043E\u0432\u044B\u0439 \u0431\u044E\u0434\u0436\u0435\u0442", submitButtonText: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C", submitButtonDisabled: data == null, children: [_jsx(CreateBudgetForm, { date: todayStr(), onChanged: setData, changeDebounceMs: 250 }), _jsx(TutorialSpotlight, { steps: CREATE_STEPS, storageKey: "tut_create_budget_v1" })] }));
}
export default ModalCreateForm;
